import { addNewMiddleWare } from 'owa-middleware';
import { errorThatWillCauseAlert } from 'owa-trace';
import { getSatchelLegacyMiddlewaresForMail } from '../getSatchelLegacyMiddlewaresForMail';
import { getSatchelMiddlewaresForMail } from '../getSatchelMiddlewaresForMail';
import { lazyBootstrapEventToCalendarAssociation } from 'mini-event-to-calendar-association';
import { lazyInitializePeopleContactStore } from 'mini-people-contact-store';
import { loadFolders } from 'mini-mail-folder-actions';
import { MAIL_LIST_RENDERED } from 'mini-app-constants/lib/commonEventSignalConstants';
import type { SessionData } from 'owa-service/lib/types/SessionData';
import { stashSessionDataResponses } from 'mini-session-storage/lib/utils/sessionDataResponseStash';
import { trackLargestSurfaceRender } from 'bootstrap/lib/trackLargestSurfaceRender';

/**
 * Function which loads the initial Mail Folders in the store
 */
export async function initializeMailModuleState(sessionData?: SessionData): Promise<void> {
    return new Promise(resolve => {
        try {
            if (sessionData) {
                stashSessionDataResponses(sessionData);
            }

            // populating the contact store so that we can take a call
            // on whether to call IAPI or GetPersonaPhoto to get the avatars.
            // This is done because IAPI doesn't support contact photos yet.
            // When it starts supporting, we'll remove this call.
            lazyInitializePeopleContactStore.importAndExecute();

            // session data is null for in app switches
            const moduleLaunchType = sessionData ? 0 : 1;
            trackLargestSurfaceRender([MAIL_LIST_RENDERED], null, null, false, moduleLaunchType);

            addNewMiddleWare(getSatchelMiddlewaresForMail(), getSatchelLegacyMiddlewaresForMail());

            loadFolders();

            lazyBootstrapEventToCalendarAssociation.importAndExecute();
        } catch (error) {
            errorThatWillCauseAlert(
                `[initializeMailModuleState]: Init state failed. ${error.message}`
            );
        } finally {
            resolve();
        }
    });
}
